import { render, staticRenderFns } from "./returnCarModal.vue?vue&type=template&id=c54127ec&scoped=true"
import script from "./returnCarModal.vue?vue&type=script&lang=js"
export * from "./returnCarModal.vue?vue&type=script&lang=js"
import style0 from "./returnCarModal.vue?vue&type=style&index=0&id=c54127ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54127ec",
  null
  
)

export default component.exports